<div class="pg-layer ui-scroll-vertical sm-scrollbar {{ShellScreen ? 'ui-background__pg-full' : ''}}" id="pgLayoutContent">
  <div class="pg-header">
    <shared-page-header></shared-page-header>
  </div>
  <div class="pg-content">
    <router-outlet></router-outlet>
  </div>
  <div class="pg-footer">
    <shared-page-footer></shared-page-footer>
  </div>
  <div class="ui-background__pg-header" *ngIf="!ShellScreen"></div>
  <div class="ui-background__pg-content" *ngIf="!ShellScreen"></div>
  <div class="ui-background__pg-footer" *ngIf="!ShellScreen"></div>
</div>

<shared-page-mobile-menu></shared-page-mobile-menu>
<shared-page-mobile-profile></shared-page-mobile-profile>
<shared-cookies-contract></shared-cookies-contract>
